import gql from 'graphql-tag';
import { toastr } from 'react-redux-toastr';

import {
  DELETE_RIDE_FARE_START,
  DELETE_RIDE_FARE_SUCCESS,
  DELETE_RIDE_FARE_ERROR
} from '../../../constants';

const mutation = gql`
mutation($id: Int!) {
  deleteRideFare(id: $id) {
    status
    errorMessage
  }
}
`;

export default function deleteRideFare(id) {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: DELETE_RIDE_FARE_START });

    try {
      const { data } = await client.mutate({
        mutation,
        variables: { id }
      });

      if (data && data.deleteRideFare && data.deleteRideFare.status === 200) {
        dispatch({ type: DELETE_RIDE_FARE_SUCCESS });
        toastr.success('Success', 'The ride fare has been deleted.');
        return { status: 200 };
      }

      const errorMessage = (data && data.deleteRideFare && data.deleteRideFare.errorMessage) || 'Oops! Something went wrong. Please try again.';
      dispatch({ type: DELETE_RIDE_FARE_ERROR });
      toastr.error('Error!', errorMessage);
      return { status: 400 };

    } catch (error) {
      dispatch({ type: DELETE_RIDE_FARE_ERROR });
      toastr.error('Error!', 'Something went wrong! ' + error);
      return { status: 400 };
    }
  };
}
